export enum BillStatementStatusWithBlock {
    None = 0,
    Open = 1, // White
    FinanceRelease = 2, // Yellow
    Issued = 3, // Green
    Canceled = 4, // Red
    Halted = 5, // Blue
    Blocked = 6, // Orange
}
